module.exports = __webpack_public_path__ + "img/ELG-min.0bdfddfb.png";